import { shallowMount } from "@vue/test-utils";
import UserNameInput from "@/components/core/UserNameInput";

describe("UserNameInput component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(UserNameInput);
  });

  it("Renders del component UserNameInput", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
